import Head from 'next/head'
import { useDispatch } from 'react-redux'
import { gotoLogIn } from '../../redux/actions/AuthActions'

import { Button, CenterContainer, Container, Description, H1, Head as Root } from './landing.styles.js'

const Header = ({ bg, title, subtitle, alt = '', meta = {} }) => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }

  return (
    <Root bg={bg} alt={alt}>
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Head>
      <Container>
        <CenterContainer>
          <H1>{title}</H1>
          <Description>{subtitle}</Description>
          <Button onClick={openLogin}>Start Designing Now</Button>
        </CenterContainer>
      </Container>
    </Root>
  )
}

export default Header
